module.exports = __webpack_public_path__ + "static/media/bs_icon.cec1a069.svg";